import { Button, Card, Col, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetActiveIntegrationAction } from "redux/action/IntegrationAction";
import { AppDispatch } from "redux/store";
import styles from "./index.module.scss";
import { getApi } from "redux/apis";
import { CssSpriteNames } from "utils/staticObject";
import TableActionHeader from "../TableActionHeader";
import "./index.scss";
import { toastText } from "utils/utils";
import NetSuiteAuthModal from "components/Modal/netSuite/netSuiteModel";

const OauthConnectApps = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data: integrationList, isLoading } = useSelector(
    (state: any) => state?.Integration
  );

  const [selectedIntegration, setSelectedIntegration] = useState<any>();
  const [netsuiteLoading, setNetsuiteLoading] = useState(false); // Separate loading state for NetSuite

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("t");
    localStorage.setItem("t", t ?? "");
  }, []);

  useEffect(() => {
    dispatch(
      GetActiveIntegrationAction({ companyId: localStorage.getItem("t") })
    );
  }, []);

  const selctIntegration = (integration: any) => {
    setSelectedIntegration(integration);
    localStorage.setItem("integration", integration.integrationName);
  };

  const connect = () => {
    setLoading(true);
    if (selectedIntegration?.integrationName === "XERO") {
      try {
        getApi(`/xero/getxerourl/${selectedIntegration.id}`).then(
          (res: any) => {
            if (res?.status === 200) {
              const authURL = res?.data?.data;
              window.open(authURL, "_self");
            }
          }
        );
      } catch (error) {
        toastText(
          "Oops! We couldn’t retrieve the authorization URL. Please try again",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
    if (selectedIntegration?.integrationName === "QUICKBOOKS") {
      try {
        getApi(`/qbo/authurl/${selectedIntegration.id}`).then((res: any) => {
          if (res?.status === 200) {
            const authURL = res?.data?.data;
            window.open(authURL, "_self");
          }
        });
      } catch (error) {
        console.error("Error fetching QBO URL:", error);
        toastText(
          "Oops! We couldn’t retrieve the authorization URL. Please try again",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
    if (selectedIntegration?.integrationName === "ZOHOBOOK") {
      try {
        getApi(`/zoho/authurl/${selectedIntegration.id}?type=zohoBook`).then(
          (res: any) => {
            if (res?.status === 200) {
              const authURL = res?.data?.data;
              window.open(authURL, "_self");
            }
          }
        );
      } catch (error) {
        console.error("Error fetching QBO URL:", error);
        toastText(
          "Oops! We couldn’t retrieve the authorization URL. Please try again",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
    if (selectedIntegration?.integrationName === "WAVEACCOUNT") {
      try {
        getApi(`/wave/authurl/${selectedIntegration.id}`).then((res: any) => {
          if (res?.status === 200) {
            const authURL = res?.data?.data;
            window.open(authURL, "_self");
          }
        });
      } catch (error) {
        console.error("Error fetching Xero URL:", error);
        toastText(
          "Oops! We couldn’t retrieve the authorization URL. Please try again",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
    if (selectedIntegration?.integrationName === "FRESHBOOKS") {
      try {
        getApi(`/fresh-books/authurl/${selectedIntegration.id}`).then(
          (res: any) => {
            console.log("cghansjjgd", res?.data?.data?.url);
            if (res?.status === 200) {
              const authURL = res?.data?.data?.url;
              window.open(authURL, "_self");
            }
          }
        );
      } catch (error) {
        console.error("Error fetching Xero URL:", error);
        toastText(
          "Oops! We couldn’t retrieve the authorization URL. Please try again",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }

    if (selectedIntegration?.integrationName === "NETSUITE") {
      console.log("selectedIntegration", selectedIntegration);
      setIsModalVisible(true);
      setLoading(false); // Stop general loading, NetSuite has its own
    }
  };

  const handleNetSuiteModalClose = () => {
    setIsModalVisible(false);
    setNetsuiteLoading(true); // Show NetSuite-specific loader

    // Simulate API call delay - replace with actual API call
    setTimeout(() => {
      setNetsuiteLoading(false); // Hide loader after API call completes (success or fail)
    }, 2000);
  };

  return (
    <>
      {netsuiteLoading ? ( // NetSuite specific loader
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Optional: Add a backdrop
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000, // Ensure it's on top
          }}
        >
          <Spin size="large" tip="Connecting to NetSuite..." />
        </div>
      ) : null}

      {loading ? ( // General loader
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <Spin size="large" tip="Connecting..." />
        </div>
      ) : !isLoading ? (
        <div className={styles["integrations"]}>
          <TableActionHeader title="Select a software you wish to connect" />
          <span className={styles["integrations__subtitle"]}>
            You will be prompted to sign in to your accounts to authorize the
            secure sharing of your financial information
          </span>
          <div className={styles["integrations__images"]}></div>
          <Row justify={"start"} gutter={25} style={{ cursor: "pointer" }}>
            {integrationList?.map((item: any) => (
              <Col
                xs={24}
                md={8}
                lg={6}
                sm={12}
                key={item.id}
                onClick={() => {
                  selctIntegration(item);
                }}
                style={{ marginBottom: 12 }}
              >
                <Card
                  bordered={true}
                  className={`card ${
                    item.id === selectedIntegration?.id ? "selected" : ""
                  }`}
                >
                  <div
                    className={
                      styles[
                        `bg-${
                          CssSpriteNames[
                            item.integrationName as keyof typeof CssSpriteNames
                          ]
                        }`
                      ]
                    }
                  ></div>
                </Card>
              </Col>
            ))}
          </Row>
          <Row justify={"start"}>
            <Button
              className={`${styles["integrations__connectbtn"]} ${
                selectedIntegration ? "connectBtn" : "disableBtn"
              }`}
              disabled={selectedIntegration ? false : true}
              onClick={connect}
              type="primary"
            >
              Connect
            </Button>
          </Row>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
          }}
        >
          <img
            src={`${process.env.REACT_APP_IMAGES_BASE_URL}/assets/gifs/loading.gif`}
            height={120}
            crossOrigin={
              process.env.REACT_APP_ENV === "local" ? undefined : "anonymous"
            }
          />
        </div>
      )}
      <NetSuiteAuthModal
        isModalVisible={isModalVisible}
        setIsModalVisible={handleNetSuiteModalClose}
      />
    </>
  );
};

export default OauthConnectApps;
